<template>
    <div v-if="distributor" class="pt-8 flex gap-4 md:gap-8 justify-between max-md:flex-col">
        <a v-bind="linkProperties" class="shrink-0">
            <EnhancedImage
                :src="cdnUrl + distributor.LogoUrl"
                :alt="distributor.Name"
                height="96"
                width="140"
                css-class="max-h-24" />
        </a>
        <div class="max-w-5xl">
            <p v-if="distributor.Description">{{ distributor.Description }}</p>
            <p>
                <a v-bind="linkProperties">
                    {{ t("Distributor.VisitSiteText", [distributor.Name]) }}
                </a>
            </p>
        </div>
    </div>
</template>
<script setup lang="ts">
const { t } = useI18n();
const config = useRuntimeConfig();
const cdnUrl = config.public.cdnUrl;

const { distributor } = injectDistributor();

const linkProperties = computed(() => {
    if (!distributor.value) return {};
    return {
        href: distributor.value.WebsiteUrl,
        rel: "noopener nofollow",
        target: "_blank",
        "data-dist": `${distributor.value.Name} [${distributor.value.DistributorId}]`,
        "data-ga": "d",
    };
});
</script>
